import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPagination = (state) => get(state, 'groups.list.pagination', {});
export const getFilters = (state) => get(state, 'groups.list.filters', {});

export const getGroupsIds = (state) => get(state, 'groups.list.result.groups', []);
export const getGroups = (state) => get(state, 'groups.list.entities.groups', []);

export const getIsLoading = (state) => get(state, 'groups.list.isLoading', false);
export const getNeedFetch = (state) => get(state, 'groups.list.needFetch', false);

export const getIsFetching = (state) => get(state, 'groups.form.isFetching', false);
export const getIsFetchingConfig = (state) => get(state, 'groups.form.isFetchingConfig', false);
export const getIsSaving = (state) => get(state, 'groups.form.isSaving', false);
export const getEditing = (state) => get(state, 'groups.form.editing', false);

export const getVisibleGroups = createSelector([getGroupsIds, getGroups], (ids, groups) =>
  ids.map((id) => groups[id]).filter((group) => !group.deleted)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/selectors/groups_selectors.js